import PropTypes from 'prop-types';
import { Check } from 'lucide-react';
import './Checkbox.css';

export default function Checkbox({
    label,
    checked = false,
    onChange,
    disabled = false,
    error,
    className = '',
    ...props
}) {
    return (
        <label className={`checkbox-wrapper ${disabled ? 'disabled' : ''} ${className}`}>
            <div className={`checkbox ${checked ? 'checked' : ''} ${error ? 'error' : ''}`}>
                <input
                    type="checkbox"
                    checked={checked}
                    onChange={(e) => onChange?.(e.target.checked)}
                    disabled={disabled}
                    {...props}
                />
                {checked && <Check size={14} />}
            </div>
            {label && <span className="checkbox-label">{label}</span>}
            {error && <span className="checkbox-error">{error}</span>}
        </label>
    );
}

Checkbox.propTypes = {
    label: PropTypes.string,
    checked: PropTypes.bool,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    error: PropTypes.string,
    className: PropTypes.string
};
